import { render } from "./ReloadPageModal.vue?vue&type=template&id=6dc43df4"
import script from "./ReloadPageModal.vue?vue&type=script&lang=js"
export * from "./ReloadPageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__